var render = function render(_c,_vm){return _c('b-icon',{staticClass:"mx-2",style:({'opacity': _vm.props.opacity}),attrs:{"icon":"box-arrow-up-right"}})
}
var staticRenderFns = []

export { render, staticRenderFns }